import { render, staticRenderFns } from "./PaginationDefault.vue?vue&type=template&id=b25f23bc&"
import script from "./PaginationDefault.vue?vue&type=script&lang=js&"
export * from "./PaginationDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports